export default __webpack_public_path__ + "static/media/deep_quote_exploration.fc4b6967.svg";